<template>
  <div id="nissan-quiz-registration-ipad" class="nissan-quiz-screen">
    <div class="text-block">
      <div class="counter" id="nissan-register-counter" v-html="timerText" v-if="this.config.tierType !== 'TIER3'"></div>
      <p class="large"><i>The game is about to begin!</i></p>
      <p class="larger" v-if="step === 'USER_OPT_IN_OPTIONS'">
        <i>Get the latest news delivered<br />right to your inbox</i>
      </p>
      <p class="larger" v-else><i>Please sign in below to play</i></p>
      <!-- <div v-if="step === 'QR_CODE_SCAN'" class="qr-code-scan">
        <QrCodeScan
          v-if="!isLoading"
          v-on:qr-code-scan-error="qrCodeScanError"
          v-on:qr-code-scan-success="qrCodeScanSuccess"
          :ref="'QrCodeScan'">
        </QrCodeScan>
        <div class="disclaimer" v-if="isLoading">
          Fetching information...
        </div>
      </div>
      <div class="disclaimer" v-if="step === 'QR_CODE_SCAN' && !isLoading">
        Scan QR Code or Hit Next to Enter Manually.
      </div>
      <button class="next-button" v-on:click="qrCodeSkipped" v-if="step === 'QR_CODE_SCAN' && !isLoading">
        <span>NEXT</span>
      </button> -->
      <form @submit.prevent="register" id="userForm" v-if="step !== 'QR_CODE_SCAN'">

        <UserLookup
          v-if="step === 'USER_LOOKUP'"
          :ref="'UserLookup'">
        </UserLookup>

        <UserRegistration
          v-if="step === 'USER_REGISTRATION'"
          :ref="'UserRegistration'">
        </UserRegistration>

        <UserOptInOptions
          v-if="step === 'USER_OPT_IN_OPTIONS'"
          :ref="'UserOptInOptions'">
        </UserOptInOptions>

        <div class="disclaimer opt-in" v-if="step === 'USER_OPT_IN_OPTIONS'">
          By checking the box above I authorize Nissan retailers to contact me for
          marketing purposes
        </div>
        <div class="disclaimer" v-else>
          By clicking Sign In, you agree to our <span class="termsLink" @click="onShowTerms">Terms</span> and that you are 18 years of age or older.
        </div>

        <div class="submit-error" v-if="isError">
          There was an error submitting your data. Please try again!
        </div>
        <div class="disclaimer" v-if="isLoading">
          Loading...
        </div>
        <button class="next-button" v-if="step === 'USER_OPT_IN_OPTIONS'">
          <span>NEXT</span>
        </button>
        <button class="submit-button" id="nissan-quiz-register-submit" v-else>
          <span>SIGN IN</span>
        </button>
      </form>
    </div>
    <div v-if="showTerms" class="termsContainer">
      <div class="closeTerms" @click="closeTerms">
        <img src="../assets/close.png" />
      </div>
      <iframe src="https://www.nissanusa.com/privacy.html?next=footer.privacy.link"></iframe>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import UserRegistration from './SignIn/UserRegistration.vue';
import UserOptInOptions from './SignIn/UserOptInOptions.vue';
import UserLookup from './SignIn/UserLookup.vue';
import QrCodeScan from './SignIn/QrCodeScan.vue';

const naughtyWords = ['4r5e', '5h1t', '5hit', 'a55', 'anal', 'anus', 'ar5e', 'arrse', 'arse', 'ass', 'ass-fucker', 'asses', 'assfucker', 'assfukka', 'asshole', 'assholes', 'asswhole', 'a_s_s', 'b!tch', 'b00bs', 'b17ch', 'b1tch', 'ballbag', 'balls', 'ballsack', 'bastard', 'beastial', 'beastiality', 'bellend', 'bestial', 'bestiality', 'bi+ch', 'biatch', 'bitch', 'bitcher', 'bitchers', 'bitches', 'bitchin', 'bitching', 'bloody', 'blow job', 'blowjob', 'blowjobs', 'boiolas', 'bollock', 'bollok', 'boner', 'boob', 'boobs', 'booobs', 'boooobs', 'booooobs', 'booooooobs', 'breasts', 'buceta', 'bugger', 'bum', 'bunny fucker', 'butt', 'butthole', 'buttmuch', 'buttplug', 'c0ck', 'c0cksucker', 'carpet muncher', 'cawk', 'chink', 'cipa', 'cl1t', 'clit', 'clitoris', 'clits', 'cnut', 'cock', 'cock-sucker', 'cockface', 'cockhead', 'cockmunch', 'cockmuncher', 'cocks', 'cocksuck', 'cocksucked', 'cocksucker', 'cocksucking', 'cocksucks', 'cocksuka', 'cocksukka', 'cok', 'cokmuncher', 'coksucka', 'coon', 'cox', 'crap', 'cum', 'cummer', 'cumming', 'cums', 'cumshot', 'cunilingus', 'cunillingus', 'cunnilingus', 'cunt', 'cuntlick', 'cuntlicker', 'cuntlicking', 'cunts', 'cyalis', 'cyberfuc', 'cyberfuck', 'cyberfucked', 'cyberfucker', 'cyberfuckers', 'cyberfucking', 'd1ck', 'damn', 'dick', 'dickhead', 'dildo', 'dildos', 'dink', 'dinks', 'dirsa', 'dlck', 'dog-fucker', 'doggin', 'dogging', 'donkeyribber', 'doosh', 'duche', 'dyke', 'ejaculate', 'ejaculated', 'ejaculates', 'ejaculating', 'ejaculatings', 'ejaculation', 'ejakulate', 'f u c k', 'f u c k e r', 'f4nny', 'fag', 'fagging', 'faggitt', 'faggot', 'faggs', 'fagot', 'fagots', 'fags', 'fanny', 'fannyflaps', 'fannyfucker', 'fanyy', 'fatass', 'fcuk', 'fcuker', 'fcuking', 'feck', 'fecker', 'felching', 'fellate', 'fellatio', 'fingerfuck', 'fingerfucked', 'fingerfucker', 'fingerfuckers', 'fingerfucking', 'fingerfucks', 'fistfuck', 'fistfucked', 'fistfucker', 'fistfuckers', 'fistfucking', 'fistfuckings', 'fistfucks', 'flange', 'fook', 'fooker', 'fuck', 'fucka', 'fucked', 'fucker', 'fuckers', 'fuckhead', 'fuckheads', 'fuckin', 'fucking', 'fuckings', 'fuckingshitmotherfucker', 'fuckme', 'fucks', 'fuckwhit', 'fuckwit', 'fudge packer', 'fudgepacker', 'fuk', 'fuker', 'fukker', 'fukkin', 'fuks', 'fukwhit', 'fukwit', 'fux', 'fux0r', 'f_u_c_k', 'gangbang', 'gangbanged', 'gangbangs', 'gaylord', 'gaysex', 'goatse', 'God', 'god-dam', 'god-damned', 'goddamn', 'goddamned', 'hardcoresex', 'hell', 'heshe', 'hoar', 'hoare', 'hoer', 'homo', 'hore', 'horniest', 'horny', 'hotsex', 'jack-off', 'jackoff', 'jap', 'jerk-off', 'jism', 'jiz', 'jizm', 'jizz', 'kawk', 'knob', 'knobead', 'knobed', 'knobend', 'knobhead', 'knobjocky', 'knobjokey', 'kock', 'kondum', 'kondums', 'kum', 'kummer', 'kumming', 'kums', 'kunilingus', 'l3i+ch', 'l3itch', 'labia', 'lust', 'lusting', 'm0f0', 'm0fo', 'm45terbate', 'ma5terb8', 'ma5terbate', 'masochist', 'master-bate', 'masterb8', 'masterbat*', 'masterbat3', 'masterbate', 'masterbation', 'masterbations', 'masturbate', 'mo-fo', 'mof0', 'mofo', 'mothafuck', 'mothafucka', 'mothafuckas', 'mothafuckaz', 'mothafucked', 'mothafucker', 'mothafuckers', 'mothafuckin', 'mothafucking', 'mothafuckings', 'mothafucks', 'mother fucker', 'motherfuck', 'motherfucked', 'motherfucker', 'motherfuckers', 'motherfuckin', 'motherfucking', 'motherfuckings', 'motherfuckka', 'motherfucks', 'muff', 'mutha', 'muthafecker', 'muthafuckker', 'muther', 'mutherfucker', 'n1gga', 'n1gger', 'nazi', 'nigg3r', 'nigg4h', 'nigga', 'niggah', 'niggas', 'niggaz', 'nigger', 'niggers', 'nob', 'nob jokey', 'nobhead', 'nobjocky', 'nobjokey', 'numbnuts', 'nutsack', 'orgasim', 'orgasims', 'orgasm', 'orgasms', 'p0rn', 'pawn', 'pecker', 'penis', 'penisfucker', 'phonesex', 'phuck', 'phuk', 'phuked', 'phuking', 'phukked', 'phukking', 'phuks', 'phuq', 'pigfucker', 'pimpis', 'piss', 'pissed', 'pisser', 'pissers', 'pisses', 'pissflaps', 'pissin', 'pissing', 'pissoff', 'poop', 'porn', 'porno', 'pornography', 'pornos', 'prick', 'pricks', 'pron', 'pube', 'pusse', 'pussi', 'pussies', 'pussy', 'pussys', 'rectum', 'retard', 'rimjaw', 'rimming', 's hit', 's.o.b.', 'sadist', 'schlong', 'screwing', 'scroat', 'scrote', 'scrotum', 'semen', 'sex', 'sh!+', 'sh!t', 'sh1t', 'shag', 'shagger', 'shaggin', 'shagging', 'shemale', 'shi+', 'shit', 'shitdick', 'shite', 'shited', 'shitey', 'shitfuck', 'shitfull', 'shithead', 'shiting', 'shitings', 'shits', 'shitted', 'shitter', 'shitters', 'shitting', 'shittings', 'shitty', 'skank', 'slut', 'sluts', 'smegma', 'smut', 'snatch', 'son-of-a-bitch', 'spac', 'spunk', 's_h_i_t', 't1tt1e5', 't1tties', 'teets', 'teez', 'testical', 'testicle', 'tit', 'titfuck', 'tits', 'titt', 'tittie5', 'tittiefucker', 'titties', 'tittyfuck', 'tittywank', 'titwank', 'tosser', 'turd', 'tw4t', 'twat', 'twathead', 'twatty', 'twunt', 'twunter', 'v14gra', 'v1gra', 'vagina', 'viagra', 'vulva', 'w00se', 'wang', 'wank', 'wanker', 'wanky', 'whoar', 'whore', 'willies', 'willy', 'xrated', 'xxx'];

export default {
  name: 'SignIn',
  components: {
    UserLookup,
    UserRegistration,
    UserOptInOptions,
    QrCodeScan,
  },
  computed: {
    ...mapGetters([
      'config',
      'remainingTimeInSeconds',
      'eventName',
    ]),
    timerText() {
      let remainingSeconds = this.remainingTimeInSeconds;
      if (remainingSeconds < 0) {
        remainingSeconds = 0;
      }
      const minutes = (Math.floor(remainingSeconds / 60));
      let seconds = remainingSeconds - (minutes * 60);
      if (seconds.toString().length === 1) {
        seconds = `0${seconds}`;
      }

      return remainingSeconds !== null ? `${minutes}:${seconds}` : '';
    },
  },
  data() {
    return {
      showTerms: false,
      step: 'USER_LOOKUP', // QR_CODE_SCAN
      isLoading: false,
      isError: false,
      userData: null,
    };
  },
  mounted() {
    // setTimeout(() => {
    //   this.qrCodeScanSuccess('A03072023B')
    // }, 5000);
  },
  methods: {
    submitUser(optIn, lead) {
      this.isLoading = true;
      this.isError = false;

      if (this.config.tierType !== 'CORP') {
        this.userData = {
          ...this.userData,
          optIn: optIn ? 'yes' : 'no',
          lead: lead ? 'yes' : 'no',
          nissanVoi: (optIn || lead) ? 'full_line' : undefined,
          nissanLeadFlag: lead ? 'yes' : undefined,
        };
      } else {
        this.userData = {
          ...this.userData,
        };
      }
      axios
        .post(
          `${this.$store.state.config.url}/trivia/event/${this.$store.state.eventId}/submitUser`,
          this.userData,
        )
        .then(() => {
          this.isLoading = false;

          this.$store.commit('setUserRegistered', { value: true });
          this.$store.commit('setActiveModule', { value: 'GameOn' });

          if (this.config.tierType !== 'CORP') {
            const data = {
              optInChecked: optIn,
              leadChecked: lead,
              eventName: this.eventName,
            };
            this.$keen.recordEvent('optInCheckboxesSubmitted', { data });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.isError = true;
          console.log(error);
        });
    },
    register() {
      // Prevent spam on buttons
      if (this.isLoading) {
        return;
      }

      if (this.step === 'USER_LOOKUP') {
        this.isLoading = true;
        this.isError = false;
        axios
          .get(`${this.$store.state.config.url}/trivia/event/${this.$store.state.eventId}/lookupUser?email=${this.$refs.UserLookup.email}&id=${this.$store.state.id}&timezone=${encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone)}&tierType=${this.config.tierType}`)
          .then((response) => {
            this.isLoading = false;
            if (response.data.found) {
              this.userData = response.data.userData;

              if (this.config.tierType !== 'CORP') {
                this.$store.state.optIn = this.userData.optIn;
                this.$store.state.lead = this.userData.lead;
                // If user has already opt-in in both, skip the opt-in screen
                if (this.userData.optIn && this.userData.lead) {
                  this.submitUser(true, true);
                } else {
                  this.step = 'USER_OPT_IN_OPTIONS';
                }
              } else {
                this.submitUser(true, true);
              }
            } else {
              this.step = 'USER_REGISTRATION';
            }
          })
          .catch((error) => {
            this.isLoading = false;
            this.isError = true;
            this.step = 'USER_REGISTRATION';
            console.log(error.response);
          });
      } else if (this.step === 'USER_REGISTRATION') {
        if (this.validateForm()) {
          this.isError = false;
          this.userData = {
            userId: this.$store.state.id,
            firstName: this.$refs.UserRegistration.firstName,
            lastName: this.$refs.UserRegistration.lastName,
            email: this.$refs.UserRegistration.email,
            zip: this.$refs.UserRegistration.zip,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            // TODO: ad event code and timezone
          };

          if (this.config.tierType !== 'CORP') {
            this.step = 'USER_OPT_IN_OPTIONS';
          } else {
            this.submitUser(true, true);
          }
        }
      } else if (this.step === 'USER_OPT_IN_OPTIONS') {
        this.submitUser(
          this.$refs.UserOptInOptions.optIn,
          this.$refs.UserOptInOptions.lead,
        );
      }
    },
    validateForm() {
      let errormsg = '';
      if (this.email === '') {
        errormsg += 'Please enter your Email\n';
      }

      if (errormsg.length > 1) {
        console.log(errormsg);
        return false;
      }

      return true;
    },
    onShowTerms() {
      window.open('https://www.nissanusa.com/privacy.html?next=footer.privacy.link', '_blank');
    },
    closeTerms() {
      this.showTerms = false;
    },
    replaceProfanity(word) {
      const replace = '';
      let returnString = word;

      const rgx = new RegExp(naughtyWords.join('|'), 'gi');
      if (rgx.test(word)) {
        console.log('i found a naughty word');
        returnString = word.replace(rgx, replace);
      }
      return returnString;
    },
    qrCodeScanError() {
      this.isLoading = false;
      this.isError = false;
      this.step = 'USER_LOOKUP';
    },
    qrCodeSkipped() {
      this.isLoading = false;
      this.isError = false;
      this.step = 'USER_LOOKUP';
    },
    qrCodeScanSuccess(tokenId) {
      this.isLoading = true;
      this.isError = false;

      axios
        .get(`${this.$store.state.config.url}/trivia/event/${this.$store.state.eventId}/lookupUserByTokenId?tokenId=${tokenId}&id=${this.$store.state.id}&timezone=${encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone)}`)
        .then((response) => {
          this.isLoading = false;
          if (response.data.found === true) {
            this.$store.commit('setUserRegistered', { value: true });
            this.$store.commit('setActiveModule', { value: 'GameOn' });
          } else {
            this.step = 'USER_REGISTRATION';
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.isError = true;
          this.step = 'USER_REGISTRATION';
          console.log(error.response);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import './../styles/_global.scss';
@import './../styles/_variables.scss';

  form {
    margin: 15px 0 0 0;
  }

  .text-block {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .qr-code-scan {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }


.counter {
  font-size: 40px;
  text-align: center;
  margin: 7px 0 0;
  // margin-top: 40px;
}

p {
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;

  &.large {
    font-size: 20px;
  }
  &.larger {
    font-size: 25px;
  }
}

@media only screen and (min-width: 600px) {
  .counter {
    font-size: 75px;
  }
  p {
    margin-left: 90px;
    margin-right: 90px;
    &.large {
      margin: 25px 0 0 0;
    }
    &.larger {
      font-size: 43px;
    }
  }
}

@media only screen and (max-width: 320px) {
  .counter {
    font-size: 35px;
    // margin-top: 60px;
  }
  p {
    margin-left: 2px;
    margin-right: 2px;
    &.large {
      font-size: 15px;
      margin: 2px 0 0 0;
    }
    &.larger {
      font-size: 15px;
    }
  }
}

.submit-button, .next-button {
  font-family: 'Nissan-Brand-Bold';
  display: block;
  height: 60px;
  width: 90%;
  color: white;
  background-color: black;
  border: 2px solid;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  margin: 25px auto 0;
}
@media only screen and (max-width: 320px) {
  .submit-button {
    font-size: 14px;
    height: 40px;
    margin: 0 auto;
  }
}

.disclaimer {

}

.submit-error {
  width: 85%;
  margin: 24px auto 0;
  text-align: center;
}

@media only screen and (max-width: 320px) {
  .disclaimer {
    font-size: 14px;
  }
  .submit-error {
    font-size: 14px;
  }
}

.termsContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: white;
}

.termsContainer > iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.closeTerms {
  background-color: gray;
  border-radius: 30px;
  width: 60px;
  height: 60px;
  position: absolute;
  z-index: 999;
  top: 25px;
  right: 25px;

  img {
    width: 40px;
    height: 40px;
    margin: 10px;
  }
}

.termsLink {
  text-decoration: underline;
}

#nissan-quiz-registration-ipad {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    margin-top: 150px;
    height: calc(100% - 150px);
}
</style>
